import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=4c41ed44&scoped=true"
import script from "./basic.vue?vue&type=script&lang=ts"
export * from "./basic.vue?vue&type=script&lang=ts"
import style0 from "./basic.vue?vue&type=style&index=0&id=4c41ed44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c41ed44",
  null
  
)

export default component.exports